import React from 'react';
import { Box, Flex, Text, Link, Heading } from '@chakra-ui/react';

export default function Footer() {
  return (
    <Box
      as="footer"
      role="contentinfo"
      bg="#1A1A1A"
      px={{ base: "20px", md: "40px" }}
      py={{ base: "30px", md: "40px" }}
    >
      <Flex
        maxW="1230px"
        mx="auto"
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align={{ base: "center", md: "flex-start" }}
        gap={{ base: "24px", md: "0" }}
      >
        {/* Left — Brand + copyright */}
        <Flex direction="column" gap="8px" align={{ base: "center", md: "flex-start" }}>
          <Text
            fontSize="20px"
            fontWeight="600"
            fontFamily="Inter, sans-serif"
            color="white"
          >
            Résonance
          </Text>
          <Text
            fontSize="14px"
            fontFamily="Inter, sans-serif"
            color="#999"
          >
            L'art de la parole et de l'écoute
          </Text>
          <Text
            fontSize="13px"
            fontFamily="Inter, sans-serif"
            color="#666"
            mt="4px"
          >
            © {new Date().getFullYear()} Résonance. Tous droits réservés.
          </Text>
        </Flex>

        {/* Right — Links */}
        <Flex
          direction="column"
          gap="10px"
          align={{ base: "center", md: "flex-end" }}
        >
          <Heading
            as="h3"
            fontSize="14px"
            fontWeight="600"
            fontFamily="Inter, sans-serif"
            color="white"
          >
            Pour nous contacter
          </Heading>
          <Link
            href="https://discord.gg/qJhmqbmcb2"
            target="_blank"
            rel="noopener noreferrer"
            fontSize="14px"
            fontFamily="Inter, sans-serif"
            color="#4DBEF8"
            _hover={{ color: "#7DD1FB", textDecoration: "none" }}
            transition="color 0.2s ease"
          >
            Envoie un message privé sur Discord
          </Link>
        </Flex>
      </Flex>
    </Box>
  );
}
